var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassToggleButtonGroup",
    {
      attrs: { value: _vm.activeFilter, exclusive: "" },
      on: { input: _vm.handleChange }
    },
    _vm._l(_vm.filtersButton, function(label, value) {
      return _c("CompassToggleButton", {
        key: value,
        attrs: { value: value, label: label }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }